import { Component, OnInit, Input } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
  FormArray,
} from '@angular/forms';

@Component({
  selector: 'app-base-form',
  templateUrl: './base-form.component.html',
  styleUrls: ['./base-form.component.scss'],
})
export class BaseFormComponent implements OnInit {
  @Input() fields: any[];
  dynamicForm: FormGroup;
  controls: any = {};
  constructor() {}
  ngOnInit(): void {
    this.fields.forEach((res) => {
      const validationsArray = [];
      res.validations.forEach((val) => {
        if (val.name === 'required') {
          validationsArray.push(Validators.required);
        }
        if (val.name === 'pattern') {
          validationsArray.push(Validators.pattern(val.validator));
        }
      });

      switch (res.type) {
        case 'multicheckbox':
          const selectedValue =
            res.value != null
              ? res.source.filter((src) => res.value.includes(src.value))
              : null;
          this.controls[res.name] = new FormControl(
            {
              value: selectedValue,
              disabled: res.disabled,
            },
            validationsArray
          );
          break;

        default:
          this.controls[res.name] = new FormControl(
            { value: res.value, disabled: res.disabled },
            validationsArray
          );
          break;
      }
      this.controls[res.name].valueChanges.subscribe((e) => {
        this.controls[res.name].setValue(e, { emitEvent: false });
      });
    });

    this.dynamicForm = new FormGroup(this.controls);
  }

  onSubmit(): void {
    console.log(this.dynamicForm.value);
  }
  getSelectSource(controls): unknown {
    if (this.dynamicForm.value[controls.parent] == null) {
      return {};
    }

    return controls.source.filter(
      (option) =>
        option[controls.parentKey] ==
        this.dynamicForm.value[controls.parent].value
    );
  }
}
